export const NO_UNITS_AVAILABLE = 'No units available';
export const NO_FACILITIES_AVAILABLE = 'No facilities available';
export const EMAIL_REQUIRED = 'Email is required.';
export const EMAIL_INVALID = 'Please enter a valid email address.';
export const PASSWORD_REQUIRED = 'Password is required.';
export const INVALID_CREDENTIALS = 'Incorrect username or password.';
export const SERVER_ERROR = 'We are experiencing some issues on our end. Please try again later.';
export const UNEXPECTED_ERROR = 'An unexpected error occurred. Please try again.';
export const ROLE_REQUIRED = 'Role is required';
export const INVALID_EMAIL_FORMAT = 'Invalid email format';
export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';

/** Shown in toasts when the API returns an error code instead of a user-friendly message. */
export const TOAST_NEUTRAL_ERROR = 'Something went wrong. Please try again.';
export const EMPTY_FIELD_ERROR = 'This field cannot be empty';
export const ERROR_USAGE = "We couldn't retrieve usage data.";
export const ERROR_LOCATION = "We couldn't retrieve location data.";
export const ERROR_WATER_CHANGE = "We couldn't retrieve water change data.";
export const ERROR_BATERY_LIFE = "We couldn't retrieve battery life data.";
export const ERROR_INVITATION_EXPIRED = 'The invitation has expired.';
export const ERROR_INVITATION_USED = 'The invitation has already been used; please log in.';
export const NO_INFORMATION_AVAILABLE = 'No information is currently available.';
